import clsx from 'clsx'

import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'

import type { TPenilaian } from 'types/kinerja-dinas'

type LocalBadgeProps = BadgeProps

type Props<T> = {
  status: T
  fallback?: (status: T) => LocalBadgeProps
}

const BadgeStatusPengiriman = <T = TPenilaian['statePengiriman'],>({
  status,
  fallback,
}: Props<T>) => {
  const getBadgeProps = (status: T): LocalBadgeProps => {
    switch (status) {
      case 'SUDAH_DIKIRIM' as unknown as T:
        return { children: 'Sudah Dikirim', variant: 'informational' }

      case 'BELUM_DIKIRIM' as unknown as T:
        return { children: 'Belum Dikirim', variant: 'critical' }

      default:
        return !!fallback
          ? fallback(status)
          : { children: 'Unknown', variant: 'informational' }
    }
  }

  const badgeProps = getBadgeProps(status)

  return (
    <Badge
      {...badgeProps}
      className={clsx('truncate', badgeProps?.className)}
    />
  )
}

export default BadgeStatusPengiriman
